import React, { useEffect, useState } from 'react';
import IconCollection from '../../IconCollection/IconCollection';
import hexToRgb from '../../utils/hexToRgb';
import { startTimer } from '../../redux/actions/timerService';
import { startJumpBallClock } from '../../redux/actions/JumpBallClockService';
import { useDispatch, useSelector } from 'react-redux';
import { matchStatusUpdate, setJumpBallTeamAPlayerRosterId, setJumpBallTeamBPlayerRosterId, togglePossessionArrowTeamOne, togglePossessionArrowTeamTwo, updateMatchTimeStatus } from '../../redux/reducers/playersReducer';
import { Toaster, toast } from 'react-hot-toast';
import { sendTimerData } from '../../redux/actions/playerAction';
import axios from 'axios';
import { baseApi } from '../../urlConfig';

const ConfirmModal = ({ isOpen, onClose, onConfirm, message, loading }) => {
  if (!isOpen) return null;

  return (
    <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[61]'>
      {
        loading ? <div className='bg-white rounded-lg p-4 max-w-sm w-full flex justify-center items-center'> <h2 className='text-lg font-bold mb-4 text-center font-montserrat'>Loading...</h2> </div> :
          <div className='bg-white rounded-lg p-4 max-w-sm w-full'>
            <h2 className='text-lg font-bold mb-4 text-center font-montserrat'>{message}</h2>
            <div className='flex justify-center gap-4 items-center'>
              <button
                onClick={onConfirm}
                className='bg-primary text-white px-4 py-2 rounded font-bebas'>
                Confirm
              </button>
              <button
                onClick={onClose}
                className='bg-black text-white px-4 py-2 rounded font-bebas'>
                Cancel
              </button>
            </div>
          </div>
      }

    </div>
  );
};

const JumpBallModal = ({
  openJumpBallModal,
  setOpenJumpBallModal,
  matchData,
  teamOnePlayersPlaying,
  shotClockValue,
  teamTwoPlayersPlaying,
  teamOneColor,
  teamTwoColor,
  teamOneName,
  teamTwoName,
  teamOneId,
  teamTwoId,
  quarter,
  teamOneJumpBallPlayer,
  teamTwoJumpBallPlayer,
  event_id,
  event_group_id,
  event_team_a_id,
  event_team_b_id,
  possessionArrowTeamOne,
  possessionArrowTeamTwo,

}) => {

  const token = localStorage.getItem('token');
  const dispatch = useDispatch();
  const activeTeamOneColor = hexToRgb(teamOneColor);
  const activeTeamTwoColor = hexToRgb(teamTwoColor);
  const teamOnePlayers = matchData.team_a_rosters;
  const teamTwoPlayers = matchData.team_b_rosters;
  const [teamOneSelectedPlayers, setTeamOneSelectedPlayers] = useState([]);
  const [teamTwoSelectedPlayers, setTeamTwoSelectedPlayers] = useState([]);
  const [isGameStarted, setIsGameStarted] = useState("Start Game");
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const { minutes, seconds, isRunning, General, remainingTime, newIsRunning, newSeconds, newMinutes } = useSelector(
    (state) => state?.settingReducer
  );
  const [isLoading, setIsLoading] = useState(false);
  const jumpBallStorageKey = event_id ? `jumpball_${event_id}` : null;
  const handleTeamOnePlayerSelect = (player) => {
    if (teamOneSelectedPlayers.some(p => p.roster_id === player.roster_id)) {
      setTeamOneSelectedPlayers([]);
    } else if (teamOneSelectedPlayers.length >= 1) {
      toast.error('You can only select one player for Team One.');
    } else {
      setTeamOneSelectedPlayers([player]);
    }
  }
  const handleTeamTwoPlayerSelect = (player) => {
    if (teamTwoSelectedPlayers.some(p => p.roster_id === player.roster_id)) {
      setTeamTwoSelectedPlayers([]);
    } else if (teamTwoSelectedPlayers.length >= 1) {
      toast.error('You can only select one player for Team Two.');
    } else {
      setTeamTwoSelectedPlayers([player]);
    }
  }

  const handleModalClose = () => {
    setOpenJumpBallModal(false);
  }


  const setStarter = async (t_id, r_id) => {
    try {
      const url = `${baseApi}/set_jumpball/`;
      const data = new FormData();
      data.append("event_id", event_id);
      data.append("eg_id", event_group_id);
      data.append("t_id", t_id);
      data.append("r_id", r_id);
      data.append("scorer_id", 1);

      const response = await axios.post(url, data, {
        headers: {
          'X-TOKEN': token,
        },
      });

      return response.data;
    } catch (error) {
      throw error;
    }
  }

  const confirmStartGame = async () => {
    setIsLoading(true);
    try {
      // Call set_jumpball for both teams when confirming to start the game
      await setStarter(teamOneId, teamOneSelectedPlayers[0].roster_id);
      await setStarter(teamTwoId, teamTwoSelectedPlayers[0].roster_id);

      // Persist jump ball selections (decoupled from lineup starters)
      dispatch(setJumpBallTeamAPlayerRosterId(teamOneSelectedPlayers[0].roster_id));
      dispatch(setJumpBallTeamBPlayerRosterId(teamTwoSelectedPlayers[0].roster_id));
      if (jumpBallStorageKey) {
        localStorage.setItem(
          jumpBallStorageKey,
          JSON.stringify({
            teamA: teamOneSelectedPlayers[0].roster_id,
            teamB: teamTwoSelectedPlayers[0].roster_id,
          })
        );
      }
      
      setIsGameStarted("Running");
      setIsConfirmOpen(false);
      setIsLoading(false);
    } catch (error) {
      console.error("Error setting jump ball:", error);
      setIsLoading(false);
      toast.error(error.message || "Failed to set jump ball. Please try again.");
    }
  }

  const setJumpBallWin = async (t_id, r_id) => {
    try {
      const url = `${baseApi}/set_jumpball_win/`;
      const data = new FormData();
      data.append("event_id", event_id);
      data.append("t_id", t_id);
      data.append("r_id", r_id);

      const response = await axios.post(url, data, {
        headers: {
          'X-TOKEN': token,
        },
      });

      return response.data;
    } catch (error) {
      throw error;
    }
  }

  const handelPossessionArrowTeam = async (value) => {
    setIsLoading(true);
    try {
      // Call set_jumpball_win for the winning team
      if (value === "teamOne") {
        await setJumpBallWin(teamOneId, teamOneSelectedPlayers[0].roster_id);
        startTimer(minutes, seconds);
        startJumpBallClock(shotClockValue);

        dispatch(matchStatusUpdate("live"));
        
        const formData = new FormData();
        formData.append("score_timer", minutes * 60 + seconds);
        formData.append("event_id", event_id);
        formData.append("eg_id", event_group_id);
        formData.append("score_period", quarter);
        formData.append("timerStatus", isRunning ? "p" : "r");
        formData.append("shotclock", shotClockValue);
        formData.append("possession", event_team_a_id);

        const response = await axios.post(`${baseApi}/set_timer/`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `${token}`,
          },
        });
        
        const game_status = response.data.game_status;
        dispatch(togglePossessionArrowTeamOne(true));
        dispatch(updateMatchTimeStatus({
          ...game_status,
        }));
        setIsLoading(false);
        handleModalClose();
      } else {
        await setJumpBallWin(teamTwoId, teamTwoSelectedPlayers[0].roster_id);
        
        startTimer(minutes, seconds);
        startJumpBallClock(shotClockValue);

        dispatch(matchStatusUpdate("live"));
        
        const formData = new FormData();
        formData.append("score_timer", minutes * 60 + seconds);
        formData.append("event_id", event_id);
        formData.append("eg_id", event_group_id);
        formData.append("score_period", quarter);
        formData.append("timerStatus", isRunning ? "p" : "r");
        formData.append("shotclock", shotClockValue);
        formData.append("possession", event_team_b_id);

        const response = await axios.post(`${baseApi}/set_timer/`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `${token}`,
          },
        });

        const game_status = response.data.game_status;
        dispatch(togglePossessionArrowTeamTwo(true));
        dispatch(updateMatchTimeStatus({
          ...game_status,
        }));
        setIsLoading(false);
        handleModalClose();
      }
    } catch (error) {
      console.error("Error:", error);
      setIsLoading(false);
      toast.error(error.message || "Failed to set starters. Please try again.");
    }
  }

  useEffect(() => {
    if (teamOneJumpBallPlayer) {
      setTeamOneSelectedPlayers([teamOneJumpBallPlayer])
    }
    if (teamTwoJumpBallPlayer) {
      setTeamTwoSelectedPlayers([teamTwoJumpBallPlayer])
    }
  }, [matchData])

  return (
    <div className={`fixed top-0 z-[60] left-0 right-0 bottom-0 bg-black bg-opacity-35 min-h-screen  justify-center items-center w-full ${openJumpBallModal ? 'flex' : 'hidden'}`}>
      <div className='max-w-[350px] md:max-w-[900px] h-[90vh]  relative w-full bg-white rounded-lg border-none py-2 md:py-10'>
       
       {
        isLoading &&
         <div className='absolute top-0 left-0 right-0 bottom-0 flex justify-center items-center bg-white z-30  rounded-lg'> 

<div className='flex justify-center items-center text-6xl font-bebas'>
        Loading...
      </div> 
         </div>
       }
        <div onClick={() => handleModalClose()} className='absolute right-4 top-4 cursor-pointer'>
          <IconCollection customClass='md:w-6 md:h-6 w-[10px] h-[10px]' name="close" />
        </div>
        <div className='w-full h-auto'>
          <div className='font-bebas border-b border-black text-xl md:text-3xl px-2 md:px-6 pt-1 md:py-4'>
            Jump Ball
          </div>
          <div className='max-h-[70vh] overflow-y-auto control-page-starter-modal mr-3'>
            <div >
              <h6 className='font-bebas text-xl md:text-3xl px-2 md:px-6 pt-1 md:py-4'>
                Step 1: pick jUMP BALL PLAYERS
              </h6>
              <div className='px-6 flex flex-col gap-4'>
                <div className='flex  gap-10 items-center'>
                  <div className='min-w-[20%] max-w-[20%]'>
                    <p className='text-xl md:text-3xl font-montserrat'>{teamOneName}</p>
                  </div>
                  <div className='min-w-[calc(80%-40px)] max-w-[calc(80%-40px)]'>
                    <div className='flex flex-wrap gap-2 justify-around'>
                      {
                        teamOnePlayersPlaying.map((player) => (
                          <button
                            onClick={() => handleTeamOnePlayerSelect(player)}
                            key={player.id}
                            className={`w-10 md:w-[88px] text-light font-bebas text-lg md:text-[64px] h-10 md:h-[88px] rounded-sm md:rounded-lg flex relative justify-center items-center disabled:bg-gray-300 `}
                            style={{
                              backgroundColor: player.roster_id && teamOneSelectedPlayers.some(item => item.roster_id === player.roster_id)
                                ? activeTeamOneColor
                                : teamOneColor
                            }}
                          >
                            {
                        player?.captain && (
                          <div className="absolute top-[3px] md:top-[3px] text-black right-[16px] md:right-[36px] font-bebas text-[5px] md:text-[8px] bg-white rounded-full md:h-3 md:w-3 h-[6px] w-[6px] leading-none flex justify-center items-center">
                            c
                          </div>
                        )
                      }

                            {player.jersey_number}</button>
                        ))
                      }
                    </div>
                    <div></div>
                  </div>
                </div>
                <div className='flex  gap-10 items-center'>
                  <div className='min-w-[20%] max-w-[20%]'>
                  </div>
                  <div className='flex flex-wrap justify-center items-center w-full gap-2 min-w-[calc(80%-40px)] max-w-[calc(80%-40px)]'>
                    {
                      teamOneSelectedPlayers.length > 0 ? teamOneSelectedPlayers.map((player, i) => (
                        <button
                          key={i}
                          className={`relative md:max-w-[108.26px] max-w-[44px]  w-full md:h-[148px] h-[60.15px] cursor-pointer `}
                        >
                          <IconCollection
                            name="player-jersey-white"
                            customClass='md:w-[108.26px] w-[44px] w-full md:h-[148px] h-[60.15px]'
                            svgFillColor={teamOneColor}
                          />
                               {
                            player?.captain && (
                             <div className="absolute top-[7px] md:top-[16px] right-4 md:right-[43px] font-bebas text-[8px] md:text-xs bg-white rounded-full md:h-5 md:w-5 h-3 w-3 leading-none flex justify-center items-center">
                                 c
                               </div>
                            )
                          }
                          <p
                            className={`font-bebas md:text-[64px] text-[28px] text-white absolute md:top-[20px] top-[9px] right-0 left-0 text-center `}
                          >
                            {player.jersey_number}
                          </p>
                          <div className='absolute md:top-[115px] top-[46px] right-0 left-0 justify-center flex md:gap-[2px] gap-[.81px] items-center'>
                            {[...Array(5)].map((_, index) => (
                              <div
                                key={index}
                                className={`border-[.67px] rounded-full
                          md:w-2 md:h-2 w-[3.25px] h-[3.25px]`
                                }
                              ></div>
                            ))}
                          </div>
                        </button>
                      ))
                        :
                        <button
                          className={`relative md:max-w-[108.26px] max-w-[44px]  w-full md:h-[148px] h-[60.15px] `}
                        >
                          <IconCollection
                            name="player-jersey-white"
                            customClass='md:w-[108.26px] w-[44px] w-full md:h-[148px] h-[60.15px]'
                            svgFillColor={teamOneColor}
                          />
                          <p
                            className={`font-bebas md:text-[64px] text-[28px] text-white absolute md:top-[20px] top-[9px] right-0 left-0 text-center `}
                          >
                          </p>
                          <div className='absolute md:top-[115px] top-[46px] right-0 left-0 justify-center flex md:gap-[2px] gap-[.81px] items-center'>
                            {[...Array(5)].map((_, index) => (
                              <div
                                key={index}
                                className={`border-[.67px] rounded-full
                          md:w-2 md:h-2 w-[3.25px] h-[3.25px]`
                                }
                              ></div>
                            ))}
                          </div>
                        </button>
                    }
                  </div>
                </div>
              </div>
              <div className='px-6 flex flex-col gap-4'>
                <div className='flex  gap-4 items-center'>
                  <div className='min-w-[20%] max-w-[20%]'>
                  </div>
                  <div className='flex flex-wrap justify-center items-center w-full gap-2 min-w-[80%] max-w-[80%]'>
                    {
                      teamTwoSelectedPlayers.length > 0 ?
                        teamTwoSelectedPlayers.map((player, i) => (
                          <button
                            key={i}
                            className={`relative md:max-w-[108.26px] max-w-[44px]  w-full md:h-[148px] h-[60.15px] cursor-pointer `}
                          >
                            <IconCollection
                              name="player-jersey-white"
                              customClass='md:w-[108.26px] w-[44px] w-full md:h-[148px] h-[60.15px]'
                              svgFillColor={teamTwoColor}
                            />
                                 {
                            player?.captain && (
                             <div className="absolute top-[7px] md:top-[16px] right-4 md:right-[43px] font-bebas text-[8px] md:text-xs bg-white rounded-full md:h-5 md:w-5 h-3 w-3 leading-none flex justify-center items-center">
                                 c
                               </div>
                            )
                          }
                            <p
                              className={`font-bebas md:text-[64px] text-[28px] text-white absolute md:top-[20px] top-[9px] right-0 left-0 text-center `}
                            >
                              {player.jersey_number}
                            </p>
                            <div className='absolute md:top-[115px] top-[46px] right-0 left-0 justify-center flex md:gap-[2px] gap-[.81px] items-center'>
                              {[...Array(5)].map((_, index) => (
                                <div
                                  key={index}
                                  className={`border-[.67px] rounded-full
                          md:w-2 md:h-2 w-[3.25px] h-[3.25px]`
                                  }
                                ></div>
                              ))}
                            </div>
                          </button>
                        ))
                        :
                        <button
                          className={`relative md:max-w-[108.26px] max-w-[44px]  w-full md:h-[148px] h-[60.15px]`}
                        >
                          <IconCollection
                            name="player-jersey-white"
                            customClass='md:w-[108.26px] w-[44px] w-full md:h-[148px] h-[60.15px]'
                            svgFillColor={teamTwoColor}
                          />
                          <p
                            className={`font-bebas md:text-[64px] text-[28px] text-white absolute md:top-[20px] top-[9px] right-0 left-0 text-center `}
                          >
                          </p>
                          <div className='absolute md:top-[115px] top-[46px] right-0 left-0 justify-center flex md:gap-[2px] gap-[.81px] items-center'>
                            {[...Array(5)].map((_, index) => (
                              <div
                                key={index}
                                className={`border-[.67px] rounded-full
                          md:w-2 md:h-2 w-[3.25px] h-[3.25px]`
                                }
                              ></div>
                            ))}
                          </div>
                        </button>
                    }
                  </div>
                </div>
                <div className='flex  gap-4 items-center'>
                  <div className='min-w-[20%] max-w-[20%]'>
                    <p className='text-xl md:text-3xl font-montserrat'>{teamTwoName}</p>
                  </div>
                  <div className='min-w-[calc(80%-40px)] max-w-[calc(80%-40px)]'>
                    <div className='flex flex-wrap gap-2 justify-around'>
                      {
                        teamTwoPlayersPlaying.map((player) => (
                          <button
                            onClick={() => handleTeamTwoPlayerSelect(player)}
                            key={player.id}
                            className={`w-10 md:w-[88px] text-light font-bebas text-lg md:text-[64px] h-10 md:h-[88px] rounded-sm md:rounded-lg flex relative justify-center items-center disabled:bg-gray-300 `}
                            style={{
                              backgroundColor: player.roster_id && teamTwoSelectedPlayers.some(item => item.roster_id === player.roster_id)
                                ? activeTeamTwoColor
                                : teamTwoColor
                            }}
                          >
                            {
                        player?.captain && (
                          <div className="absolute top-[3px] md:top-[3px] text-black right-[16px] md:right-[36px] font-bebas text-[5px] md:text-[8px] bg-white rounded-full md:h-3 md:w-3 h-[6px] w-[6px] leading-none flex justify-center items-center">
                            c
                          </div>
                        )
                      }

                            {player.jersey_number}</button>
                        ))
                      }
                    </div>
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
            <div className='w-full h-[1px] bg-black my-5'></div>
            {
              teamOneSelectedPlayers.length > 0 && teamTwoSelectedPlayers.length > 0 && (
                <div>
                  <div className='font-bebas  text-xl md:text-3xl px-2 md:px-6 pt-1 md:py-4'>
                    Step 2: start the game
                  </div>
                  <div className='px-6 pb-6'>
                    <button
                      onClick={() => setIsConfirmOpen(true)}
                      disabled={isLoading || isGameStarted === "Running"}
                      className='dropdown-header  custom-drop-shadow text-[#4A4A4A] font-bebas text-[10px] lg:text-2xl lg:max-w-[125px] max-w-[58px] p-[4.5px] lg:p-3 h-[30px] lg:h-14 rounded  cursor-pointer w-full flex justify-between items-center '>
                      {isLoading ? 'Loading...' : isGameStarted}
                    </button>
                  </div>
                  <div className='w-full h-[1px] bg-black my-5'></div>
                </div>
              )
            }
            {
              isGameStarted === "Running" && (
                <div>
                  <div className='font-bebas  text-xl md:text-3xl px-2 md:px-6 pt-1 md:py-4'>
                    Step 3: SELECT THE TEAM WHO wins the jump ball 
                  </div>
                  <div className='flex gap-4 items-center px-6'>
                    <button
                      onClick={() => handelPossessionArrowTeam("teamOne")}
                      style={{
                        backgroundColor: teamOneColor
                      }}
                      className='px-4 py-4  flex justify-center items-center min-h-12 rounded-lg text-white font-montserrat text-2xl'>
                      {teamOneName}
                    </button>
                    <button
                      onClick={() => handelPossessionArrowTeam("teamTwo")}
                      style={{
                        backgroundColor: teamTwoColor
                      }}
                      className='px-4 py-4  flex justify-center items-center min-h-12 rounded-lg text-white font-montserrat text-2xl'>
                      {teamTwoName}
                    </button>
                  </div>
                </div>
              )
            }
          </div>
        </div>
      </div>
      <ConfirmModal
        isOpen={isConfirmOpen}
        onClose={() => setIsConfirmOpen(false)}
        onConfirm={confirmStartGame}
        message="Are you sure you want to start the game?"
        loading={isLoading}
      />
    </div>
  );
};

export default JumpBallModal;